<template>
  <div class="bg-white border border-gray-50 rounded overflow-hidden">
    <table class="w-full text-sm">
      <colgroup>
        <col style="width: 15%" />
        <col style="width: 33%" />
        <col style="width: 14%" />
        <col style="width: 13%" />
        <col style="width: 15%" />
        <col style="width: 10%" />
      </colgroup>
      <thead>
        <tr class="bg-gray-25 border-b border-gray-50 text-left text-gray-600" style="font-size: 9.5px">
          <th class="pl-4 py-2 font-medium uppercase tracking-wide">Pull request</th>
          <th class="py-2 font-medium uppercase tracking-wide">Title</th>
          <th class="py-2 font-medium uppercase tracking-wide">Category</th>
          <th class="py-2 font-medium uppercase tracking-wide">Delivery</th>
          <th class="py-2 font-medium uppercase tracking-wide">Customer link</th>
          <th class="pr-4 py-2 font-medium uppercase tracking-wide">Engineer</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!pullRequests.length">
          <td colspan="6" class="pl-4 py-8 text-gray-600">
            No pull requests in this category.
          </td>
        </tr>
        <template v-for="pr in pullRequests" :key="pr.id">
          <tr
            class="border-b border-gray-25 hover:bg-gray-10 cursor-pointer align-middle"
            :class="{ 'opacity-50': !hasRequirement(pr) }"
            @click="toggle(pr.id)"
          >
            <td class="pl-4 py-3">
              <a
                :href="pr.url"
                target="_blank"
                rel="noopener"
                class="text-primary-700 hover:underline font-mono"
                style="font-size: 11px"
                @click.stop
              >{{ pr.repository }}#{{ pr.pr_number }}</a>
            </td>
            <td class="py-3 text-gray-900">{{ pr.title }}</td>
            <td class="py-3 text-gray-700" style="font-size: 11px">
              {{ categoryLabel(pr.primary_category) }}
            </td>
            <td class="py-3 text-gray-700" style="font-size: 11px">
              {{ deliveryLabel(pr.delivery_state) }}
            </td>
            <td class="py-3" style="font-size: 11px">
              <!-- Weight, not colour. A PR with no customer link is not an
                   error — it is a fact worth being able to scan down a column.
                   See app_ui/components, dense list rows. -->
              <span :class="hasRequirement(pr) ? 'text-gray-900 font-medium' : 'text-gray-300'">
                {{ linkageLabel(pr.customer_linkage) }}
              </span>
            </td>
            <td class="pr-4 py-3 text-gray-700" style="font-size: 11px">
              {{ pr.engineer_id || pr.author_login || '—' }}
            </td>
          </tr>
          <tr v-if="expandedId === pr.id" class="border-b border-gray-50 bg-gray-10">
            <td colspan="6" class="px-4 py-4">
              <p class="text-gray-900 mb-2">{{ pr.summary }}</p>
              <p v-if="pr.strategic_rationale" class="text-gray-700 mb-2" style="font-size: 11px">
                {{ pr.strategic_rationale }}
              </p>
              <p v-if="hasRequirement(pr)" class="text-gray-700" style="font-size: 11px">
                Implements
                <a
                  v-for="id in pr.requirement_ids"
                  :key="id"
                  :href="`/support/work/${id}`"
                  class="text-primary-700 hover:underline mr-2"
                >#{{ id }}</a>
              </p>
              <p v-else class="text-gray-600" style="font-size: 11px">
                No requirement is linked to this pull request.
              </p>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  CATEGORY_LABELS,
  DELIVERY_LABELS,
  LINKAGE_LABELS,
} from './hades_constants';

export default {
  name: 'Hades_PRTable',
  props: {
    pullRequests: { type: Array, required: true },
  },
  data() {
    return { expandedId: null };
  },
  methods: {
    toggle(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },
    hasRequirement(pr) {
      return !!(pr.requirement_ids && pr.requirement_ids.length);
    },
    categoryLabel(category) {
      return CATEGORY_LABELS[category] || category;
    },
    deliveryLabel(delivery) {
      return DELIVERY_LABELS[delivery] || delivery;
    },
    linkageLabel(linkage) {
      return LINKAGE_LABELS[linkage] || linkage;
    },
  },
};
</script>
